<template>
  <header class="app-integration-steps">
    <h3 class="app-integration-steps__title">
      Precisamos de alguns dados para integrar com o Marketplace Dr. Conecta e Agenda Online
    </h3>

    <transition name="fade">
      <ol class="app-integration-steps__list">
        <li
          v-for="step in steps"
          :key="`app-integration-step-${step.step}`"
          class="app-integration-steps__item"
        >
          <span
            v-if="!showTick(step)"
            :class="[
              step.step === currentStep && 'app-integration-steps__badge--current',
              showLink(step) && 'clickable'
            ]"
            class="app-integration-steps__badge"
            @click="$router.push({ name: step.route })"
          >
            {{ step.step }}
          </span>

          <span
            v-else
            :class="showLink(step) && 'clickable'"
            class="app-integration-steps__badge app-integration-steps__badge--done"
            @click="$router.push({ name: step.route })"
          >
            <i class="icon icon-check" />
          </span>

          <router-link
            v-if="showLink(step)"
            :to="{ name: step.route }"
            tag="div"
            class="app-integration-steps__link"
          >
            {{ step.name }}
          </router-link>

          <div
            v-else
            class="app-integration-steps__link"
            style="cursor: default"
          >
            {{ step.name }}
          </div>
        </li>
      </ol>
    </transition>

  </header>
</template>

<script>
import EventBus from '@/globals/eventBus'
import { mapGetters } from 'vuex'

export default {
  name: 'AppIntegrationSteps',

  props: {
    currentStep: {
      type: Number,
      required: true,
      default: () => 1
    }
  },

  data () {
    return {
      steps: [
        {
          step: 1,
          name: 'Apresentação e Formação',
          route: 'DoctorAppIntegrationEducation',
          slug: 'apresentacao-e-formacao',
          requires: []
        },
        {
          step: 2,
          name: 'Consultório e Teleconsulta',
          route: 'DoctorAppIntegrationOffices',
          slug: 'periodo-e-preco',
          requires: ['apresentacao-e-formacao']
        },
        {
          step: 3,
          name: 'Período e Preços',
          route: 'DoctorAppIntegrationPrices',
          slug: 'periodo-e-preco',
          requires: ['apresentacao-e-formacao']
        },
        {
          step: 4,
          name: 'Dados Bancários',
          route: 'DoctorAppIntegrationFinance',
          slug: 'dados-bancarios',
          requires: ['apresentacao-e-formacao', 'periodo-e-preco']
        },
        {
          step: 5,
          name: 'Marketplace',
          route: 'DoctorAppIntegrationHealthPlace',
          slug: 'dados-bancarios',
          requires: ['apresentacao-e-formacao', 'periodo-e-preco', 'dados-bancarios']
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      userSteps: 'getAppIntegration',
      healthPlaceIntegration: 'getHealthPlaceIntegration'
    })
  },

  methods: {
    showTick (step) {
      if (this.userSteps && step.step <= 4) {
        const takenSteps = this.userSteps['app_integration_stages']
          .map(s => s.slug)
        const isStepTaken = takenSteps.includes(step.slug)

        if (isStepTaken || this.currentStep > step.step) {
          return true
        }
      } else {
        if (
          this.healthPlaceIntegration &&
          'is_active' in this.healthPlaceIntegration &&
          this.healthPlaceIntegration['is_active']
        ) {
          return true
        }
      }

      return false
    },

    showLink (step) {
      if (this.userSteps) {
        const takenSteps = this.userSteps['app_integration_stages']
          .map(s => s.slug)
        const isRequiredTaken = step.requires.every(i => takenSteps.includes(i))

        return isRequiredTaken
      }

      return false
    }
  }
}
</script>
